import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import DesignerMain from "./DesignerMain";
import { Box } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import { StyleSettings } from "src/styles/StyleSettings";
import { getTablebySql, getInitForm } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import axios from "axios";

export default function Drawing() {
  const [open, setOpen] = useState(false);
  const fontSize = StyleSettings.font;
  const MenusidebarRef = useRef<any>(null);
  const mainRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [inputValue, setInputValue] = useState<string>("");
  const [options, setOptions] = useState<any[]>([]);
  const [loadData, setLoadData] = useState<any>();
  const [noIssue, setnoIssue] = useState<string | null>(null);
  const [cdmenu, setCdmenu] = useState<string | null>(null);
  const [cdTemplate, setCdTemplate] = useState<string | null>(null);
  const { userInfo } = global();

  useEffect(() => {
    const fetchOptions = async () => {
      const rtn = await getTablebySql({
        sql: "select cd_menu, nm_menu, cd_module, fg_menu from sys_mmenu where fg_menu in ('REP', 'REG')",
      });
      setOptions(rtn);
      const params = new URLSearchParams(window.location.search);
      setnoIssue(params.get("noissue"));
      setCdmenu(params.get("cdmenu"));
      const rtn2 = await getTablebySql({
        sql: `select cd_template, js_setting from sfa_issue_design where no_issue = '${params.get("noissue")}'`,
      });
      if (rtn2.length > 0) {
        setLoadData(JSON.parse(rtn2[0].js_setting.value));
        setCdTemplate(rtn2[0].cd_template);
      }
    };
    fetchOptions();
  }, []);

  const [selectedOption, setSelectedOption] = useState<any | null>(null);
  // 바깥 클릭 시 메뉴 닫기
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const ref = MenusidebarRef.current.getRef();
      if (ref && !ref.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleChange = (e: SyntheticEvent, value: any) => {
    loadform(value);
    setSelectedOption(value);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLDivElement> & {
      defaultMuiPrevented?: boolean;
    }
  ) => {
    if (e.key === "Enter") {
      const currentValue = inputRef.current?.value;
      // currentValue와 options에서 nm_path가 포함되는 항목을 필터링
      const filtered = options.filter(
        (option) =>
          currentValue &&
          (option.nm_menu.trim() === currentValue.trim() ||
            option.cd_menu.trim() === currentValue.trim())
      );
      if (filtered.length === 1) {
        const value = filtered[0];
        loadform(value);
        setSelectedOption(value);
      }
    }
  };
  const loadform = async (params: any) => {
    try {
      const rtn: any = await getInitForm({
        cd_menu: params.cd_menu,
        cd_moudule: params.cd_module,
      });
      setLoadData(rtn);
      setInputValue("");
    } catch (error) {}
  };

  const handleInputChange = (
    e: SyntheticEvent,
    value: string,
    reason: string
  ) => {
    switch (reason) {
      case "input":
        setInputValue(value);
        break;
      case "clear":
        setInputValue("");
        break;
    }
  };

  /**
   * x 버튼 클릭 시 동작할 메서드
   */
  const handleClear = () => {
    setInputValue("");
  };

  const downLoadFront = () => {
    mainRef.current?.downLoadFront();
  };

  const downLoadBack = () => {
    mainRef.current?.downLoadBack();
  };

  // start 하기 전의 이슈만 저장 가능
  // 저장이 꼭 필요하면 업무서버 db에서 이슈 상태를 잠깐 바꿔서 저장해주세요
  const save = async () => {
    // 이슈 상태 체크
    const param = {
      id: "com_designer_01",
      params: {
        no_issue: noIssue,
      },
    };
    const data = await fnGetDataSet(param);
    if (data[0] && data[0].length > 0) {
      const st_issue = data[0][0].st_issue;
      if (st_issue === "0" || st_issue === "1" || st_issue === "2") {
        mainRef.current?.save();
      } else {
        await showDialog(
          "alter",
          "이미 진행된 이슈입니다. 이슈 상태를 확인해주세요."
        );
      }
    } else {
      await showDialog("alter", "이슈번호가 없습니다.");
    }
  };

  // 개발서버 배포 시, sfa_issue_design 테이블을 기준으로 배포
  const deploy = async () => {
    // 1. 개발서버 sys_mmenu의 메뉴코드 확인 → 없으면 배포 X
    try {
      const params = {
        id: "com_CommonMapper_02",
        params: {
          sql: "select count(*) from sys_mmenu where cd_menu = :cd_menu;",
          cd_menu: cdmenu,
        },
      };
      const response = await axios.post(
        "http://183.111.205.170:7003/snotes/getTablebySql",
        params,
        {
          headers: {
            Authorization: "f5pjbv4xl6cn1awryg3s2km7qdu0htei",
            "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
          },
        }
      );
      const data = response.data[0];
      const count = data[0].count;
      if (count === 0) {
        await showDialog(
          "alter",
          "개발서버에 없는 메뉴 코드입니다. " +
            "\n메뉴 등록 후 진행해주세요." +
            "\n\n[메뉴등록순서]" +
            "\n1. 업무서버의 노츠메뉴관리에서 메뉴 등록" +
            "\n2. 개발서버의 회사메뉴관리에서 메뉴동기화 버튼 클릭 후 메뉴 권한 할당" +
            "\n3. 그룹메뉴관리 또는 사용자메뉴관리에서 권한 추가"
        );
        return;
      }
    } catch (error) {
      console.error("API 호출 실패1", error);
      await showDialog("error", "개발서버와의 통신 실패");
      return;
    }

    // 2. 마지막으로 저장된 loadData 조회 → 저장된 데이터 없으면 배포 X
    let lastLoadData;
    const rtn = await getTablebySql({
      sql: `select js_setting from sfa_issue_design where no_issue = '${noIssue}'`,
    });
    if (rtn.length > 0) {
      lastLoadData = JSON.parse(rtn[0].js_setting.value);
    }
    if (!lastLoadData) {
      await showDialog("alter", "저장된 데이터가 없습니다.");
      return;
    }

    // 3. 개발서버 formctrl, formgridcolumn 삭제
    try {
      const sql = `delete from sys_formctrl where cd_firm = '${userInfo.cd_firm}' and cd_menu = '${cdmenu}'; delete from sys_formgridcolumn where cd_firm = '${userInfo.cd_firm}' and cd_menu = '${cdmenu}';`;
      const params = {
        fg_script: "",
        query: sql,
      };
      const response = await callApi(
        "http://183.111.205.170:7003/snotes/executeScript/do",
        params
      );

      const status = response?.status;
      if (!status) {
        // 오류
        await showDialog("error", "기존 데이터 삭제 실패.");
        return;
      }
    } catch (error) {
      console.error("API 호출 실패1", error);
      await showDialog("error", "기존 데이터 삭제 실패.");
      return;
    }

    // 4. 개발서버에 보낼 데이터 생성
    try {
      const searchControl = lastLoadData.formControlData;
      const gridColumn = Object.values(lastLoadData.grid || {}).flat();

      const freeformControl = lastLoadData.form?.freeform1;

      const formCtrl = [...(searchControl || []), ...(freeformControl || [])];
      const formGridColumn = gridColumn;

      formCtrl.forEach((item: any) => {
        item.cd_menu = cdmenu;
      });
      formGridColumn.forEach((item: any) => {
        item.cd_menu = cdmenu;
      });

      const SaveData1 = {
        sys_formctrl: { insert: formCtrl },
      };
      const response1 = await callApi(
        "http://183.111.205.170:7003/snotes/SN_SYS_BAS_REG_006_SAVE_01",
        SaveData1
      );
      const status1 = response1.status;
      if (!status1) {
        await showDialog("error", "저장 데이터 복사 실패.");
        return;
      }

      const SaveData2 = {
        sys_formgridcolumn: { insert: formGridColumn },
      };
      const response2 = await callApi(
        "http://183.111.205.170:7003/snotes/SN_SYS_BAS_REG_007_SAVE_01",
        SaveData2
      );
      const status2 = response2.status;
      if (status1 && status2)
        await showDialog("success", "개발서버로 데이터 이관 성공.");
    } catch (error) {
      console.error("API 호출 실패1", error);
      await showDialog("error", "저장 데이터 복사 실패.");
      return;
    }
  };

  /**
   * 개발서버로 요청보낼 때 사용하는 공통함수
   */
  const callApi = async (url: string, params: any): Promise<any> => {
    try {
      const header = {
        headers: {
          Authorization: "f5pjbv4xl6cn1awryg3s2km7qdu0htei",
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      };
      const response = await axios.post(url, params, header);
      const result = response?.data?.result;
      const if_status = result?.if_status || "";
      if (if_status === "E") {
        // 오류
        await showDialog("error", "저장 데이터 배포 실패.");
        return { status: "E", data: result?.return_item };
      }
      return { status: if_status === "S", data: result?.return_item };
    } catch (error: any) {
      await showDialog("error", error.message);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        // overflowX: "auto",
      }}
    >
      <div className="min-h-screen bg-gray-100">
        {/* 상단 헤더 */}
        <div className="flex items-center justify-between bg-blue-600 px-4 h-14 shadow-md">
          {/* 햄버거 메뉴 */}
          <div
            className="flex flex-col justify-center cursor-pointer w-6 h-6"
            onClick={() => setOpen(!open)}
          >
            <span className="h-0.5 bg-white mb-1"></span>
            <span className="h-0.5 bg-white mb-1"></span>
            <span className="h-0.5 bg-white"></span>
          </div>

          {/* 검색창 */}
          <div className="w-[300px] mr-2">
            <Autocomplete
              value={selectedOption}
              selectOnFocus={false}
              disableClearable={false}
              blurOnSelect
              options={options}
              isOptionEqualToValue={() => false}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              getOptionLabel={(option) => `[${option.cd_menu}]`}
              filterOptions={(options, state) => {
                if (!state.inputValue.trim()) {
                  return [];
                }
                return options.filter(
                  (option) =>
                    option.cd_menu.includes(state.inputValue) ||
                    option.nm_menu.includes(state.inputValue)
                );
              }}
              inputValue={inputValue}
              onInputChange={handleInputChange}
              slotProps={{
                popper: {
                  style: { width: "480px" },
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [90, 4], // (450 - 300) / 2 = 75, 오른쪽으로 75px 당기기
                      },
                    },
                  ],
                },
              }}
              renderOption={(props, option) => {
                return (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      fontSize: fontSize,
                      //fontFamily: "monospace", // 정렬 잘 되도록
                    }}
                  >
                    <span style={{ width: "230px", flexShrink: 0 }}>
                      {option.cd_menu}
                    </span>
                    <span>: {option.nm_menu}</span>
                  </li>
                );
              }}
              renderInput={(params) => (
                <div className="h-8">
                  <TextField
                    {...params}
                    inputRef={inputRef}
                    placeholder="검색"
                    className="h-full w-full"
                    sx={{
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "999px", // ✅ 외부 div에 둥글게
                      "& .MuiInputBase-root": {
                        height: "100%",
                        borderRadius: "999px", // ✅ 내부 input도 둥글게
                        fontSize: fontSize,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "gray.400",
                        borderRadius: "999px", // ✅ 테두리도 둥글게
                      },
                      "& .MuiInputBase-input": {
                        height: "100%",
                        padding: "0 12px",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                </div>
              )}
              forcePopupIcon={false}
            />
          </div>
          {/* 다운로드 버튼 */}
          <div className="flex flex-row items-center gap-2">
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={save}
            >
              <span className="text-sm font-medium">저장</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={deploy}
            >
              <span className="text-sm font-medium">배포</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={downLoadFront}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                />
              </svg>
              <span className="text-sm font-medium">Front</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={downLoadBack}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                />
              </svg>
              <span className="text-sm font-medium">Back</span>
            </button>
          </div>
        </div>

        {/* 사이드바 */}
        <DesignerMain
          loadData={loadData}
          menuOptions={selectedOption}
          ref={mainRef}
          cdMenu={cdmenu || ""}
          noIssue={noIssue || ""}
          cdTemplate={cdTemplate || ""}
        />
      </div>
    </Box>
  );
}
